import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react"
import { XMarkIcon } from "@heroicons/react/20/solid"
import { useRef } from "react"

const HelpModal = ({
  setIsOpen,
  isOpen,
}: {
  setIsOpen: (state: boolean) => void
  isOpen: boolean
}) => {
  const closeButtonRef = useRef<HTMLButtonElement | null>(null)

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <>
      <Transition appear show={isOpen} as="div">
        <Dialog
          as="div"
          className="prose fixed inset-0 z-30 font-sans"
          initialFocus={closeButtonRef}
          onClose={closeModal}
        >
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/10 backdrop-blur-sm" />
          </TransitionChild>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <TransitionChild
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <DialogPanel
                  className="relative mx-8 w-full max-w-2xl overflow-hidden rounded-2xl bg-white px-6 
                pb-6 text-left align-middle shadow-xl transition-all"
                >
                  <DialogTitle className="mt-6">Help</DialogTitle>
                  <button
                    ref={closeButtonRef}
                    type="button"
                    className="absolute right-5 top-4 inline-flex justify-center rounded-md
                    border border-transparent bg-blue-100 p-1 text-sm
                    font-medium text-blue-900 hover:bg-blue-200
                    focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={closeModal}
                  >
                    <XMarkIcon className="size-5" />
                    <span className="sr-only">Close</span>
                  </button>
                  <Description className="text-sm text-gray-500">
                    Watch this video to learn how you can use the Chuukese Bible website.
                  </Description>
                  <script src="https://player.vimeo.com/api/player.js"></script>
                  <div className="relative mt-5 pt-[50%]">
                    <iframe
                      src="https://player.vimeo.com/video/842945338/?h=18f3c5a1ea&badge=0&autopause=0&player_id=0&app_id=58479&loop=0"
                      allow="autoplay; fullscreen"
                      allowFullScreen
                      title="Chuukese Bible: Help"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        borderWidth: 0,
                      }}
                    ></iframe>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default HelpModal
